import { axiosClient, TUserType } from '@definitions'
import { AxiosResponse } from 'axios'
import { SociodemographicFieldValueApiType, UserApiType } from '@api/types'
import { catchApiError } from '@utils'

export const getUser = async (): Promise<UserApiType> => {
  try {
    const axios = axiosClient()
    const resp: AxiosResponse<UserApiType> = await axios.get(`/UserService/User/GetUser`)
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}

export type UpdateUserPayloadType = {
  idUser: string
  phone: string
  lastName: string
  firstName: string
  type?: TUserType
  birthDate?: string
  nationality?: SociodemographicFieldValueApiType
}
export const updateUser = async (user: UpdateUserPayloadType): Promise<UserApiType> => {
  try {
    const axios = axiosClient()
    const resp: AxiosResponse<UserApiType> = await axios.put(`/UserService/User/UpdateUser`, user)
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}

export type UpdateUserSociodemographicPayloadType = {
  idUser: string
  earning: SociodemographicFieldValueApiType
  study: SociodemographicFieldValueApiType
  family: SociodemographicFieldValueApiType
  children: SociodemographicFieldValueApiType
  job: SociodemographicFieldValueApiType
  activitySector: SociodemographicFieldValueApiType
}
export const updateUserSociodemographic = async (
  user: UpdateUserSociodemographicPayloadType,
): Promise<UserApiType> => {
  try {
    const axios = axiosClient()
    const resp: AxiosResponse<UserApiType> = await axios.put(
      `/UserService/User/UpdateSocioDemographic`,
      user,
    )
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}

export type UpdateUserAddressPayloadType = {
  idUser: string
  address: {
    path?: string
    zipCode?: string
    city?: string
    department?: SociodemographicFieldValueApiType
    region?: SociodemographicFieldValueApiType
    country?: SociodemographicFieldValueApiType
  }
}
export const updateUserAddress = async (
  user: UpdateUserAddressPayloadType,
): Promise<UserApiType> => {
  try {
    const axios = axiosClient()
    const resp: AxiosResponse<UserApiType> = await axios.put(
      `/UserService/User/UpdateAddress`,
      user,
    )
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}

export type UpdateUrlAvatarUserPayloadType = {
  idUser: string
  file: File
}
export const updateUrlAvatarUser = async (
  payload: UpdateUrlAvatarUserPayloadType,
): Promise<string> => {
  try {
    const axios = axiosClient({
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    const formData = new FormData()
    formData.append('IdUser', payload.idUser)
    formData.append('file', payload.file)
    const resp: AxiosResponse<string> = await axios.post(
      `/UserService/User/UploadAvatarFile`,
      formData,
    )
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}
